module.exports = "/_next/static/images/0c165b1512d44665f2cfa327749ad72a-mastercard-left-lg.jpg";